import React, { Fragment } from 'react';

import ReleaseNotes from './ReleaseNotes';
import Status from './Status';

/* eslint-disable react/display-name */
const LibraryStatus = {
  Status: () => <Status />,
  ReleaseNotes: () => <ReleaseNotes />,
  Usage: () => <Fragment>Usage</Fragment>,
  GitRepo: () => <Fragment>GuitRepo</Fragment>,
};

export default LibraryStatus;



// WEBPACK FOOTER //
// ./src/containers/libraryStatus/index.js